<template>
  <div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import {
  OIL_TYPE,
  REFINERY_NAME,
  REFINERY_ID,
  TANKER_TYPE,
  STATIONS,
} from "../constant/index";

export default {
  components: {
  },
  data() {
    return {
      vessel: [],
      config: {
        startDate: moment().format("DD/MM/YYYY"),
        endDate: moment().format("DD/MM/YYYY"),
        destination_type: "transit",
        isDomestic: "false",
      },
    };
  },
  computed: {
    ...mapState({
      vesselTrip: (state) => state.vesselTrip.data,
      tankers: (state) => state.mpVesselData.tankers,
      transferLogs: (state) => state.mpVesselData.transferLogs,
    }),
    ...mapGetters({
      getMpTankerName: "getMpTankerName",
      getMpVesselName: "getMpVesselName",
    }),
  },
  async mounted() {
    await this.$store.dispatch("getVesselTrip", this.config);
    await this.$store.dispatch("getMpTankerAll");
  },
  watch: {
    async vesselTrip(val) {
      this.getVesselData();
      const vesselMMSI = _.map(this.vesselTrip, (a) => {
        const mmsi = a.vessel.mmsi;
        return {
          mmsi,
        };
      });
      for (let i = 0; i < vesselMMSI.length; i++) {
        await this.$store.dispatch("getMPTankerByMMSI", vesselMMSI[i].mmsi);
        if (!_.isEmpty(this.tankers[i])) {
          this.$store.dispatch("getMpTranferLogs", this.tankers[i]);
        }
      }
      this.setUpTransferLogs(this.transferLogs);
    },
    transferLogs(val, oldVal) {
      if (val != oldVal) {
        for (let i = 0; i, val.length; i++) {
          this.$store.dispatch("getMpAllStations");
        }
      }
    },
    
  },
  methods: {
    getVesselData() {
      const data = _.chain(this.vesselTrip)
        .groupBy("station_id")
        .map((o, i) => {
          const children = _.map(o, (a) => {
            return {
              id: a.vessel.id,
              name: a.vessel.name,
              mmsi: a.vessel.mmsi,
              value: _.reduce(
                o,
                (sum, a) => {
                  let volumes = _.get(a, "volumes").map((a) => {
                    return Number(a);
                  });
                  return sum + _.sum(volumes);
                },
                0
              ),
              type: "Tanker",
            };
          });
          return {
            ...children,
          };
        })
        .value();
      this.vessel = data;
    },

    setUpTransferLogs(data) {
      const setUpDATA = _.map(data, (x) => {
        const tanker_name = this.getMpTankerName(x.tanker_id) || null;
        const vessel_name = this.getMpVesselName(x.vessel_id) || null;
        return {
          ...x,
          // station_name,
          tanker_name,
          vessel_name,
        };

      });
      console.log(setUpDATA);
      const children = _.map(setUpDATA,(x) =>{
        if(!_.isEqual(x.tanker_id,null)){
          return{
            id: x.tanker_id,
            name: x.tanker_name,
            volume: x.volume,
            transfer_date: x.transfer_date
          }
        }
      })
      const withOutData = _.without(children,undefined);
      this.vessel = withOutData
      console.log(this.vessel);
    },
  
  },
};
</script>

<style></style>
